import React, { useContext, useEffect, useState } from 'react'
import { UserContext } from '../../App';
import { LogInSchoolID } from '../../JS/Common';
import { ApiPostCall } from '../../JS/Connector';
import AlertsComp from '../../Components/AlertsComp';
import { useDefaultShipMethodCall } from '../../Hooks';
import SettingBoxWrapper from './SettingBoxWrapper';

export default function DefaultShipMethod({ setLoading, setNewAlerts }) {
    const { UserData } = useContext(UserContext);
    const [defaultShipMethod, setDefaultShipMethod] = useState(UserData.defaultShipMethod)

    const { DefaultShipMethodCall } = useDefaultShipMethodCall();

    useEffect(() => {
        setDefaultShipMethod(UserData.defaultShipMethod)
    }, [UserData.defaultShipMethod])

    return (
        <>
            <SettingBoxWrapper
                BoxTitle={'Default Shipping Method'}
                BoxLabel={`Would you like to set a default shipping method for new batches?`}
            >
                <div className='col-md-12 mt-3 d-flex align-items-center'>
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            name='DefaultShipMethod'
                            onChange={(e) => setDefaultShipMethod(1)}
                            checked={defaultShipMethod == 1}
                            id='Fedex'
                        />
                        <label className="form-check-label" htmlFor='Fedex'>FedEx</label>
                    </div>
                    <div className="form-check ms-5">
                        <input
                            className="form-check-input"
                            type="radio"
                            name='DefaultShipMethod'
                            onChange={(e) => setDefaultShipMethod(2)}
                            checked={defaultShipMethod == 2}
                            id='Ups'
                        />
                        <label className="form-check-label" htmlFor='Ups'>UPS</label>
                    </div>
                    <div className="form-check ms-5">
                        <input
                            className="form-check-input"
                            type="radio"
                            name='DefaultShipMethod'
                            onChange={(e) => setDefaultShipMethod(3)}
                            checked={defaultShipMethod == 3}
                            id='Usps'
                        />
                        <label className="form-check-label" htmlFor='Usps'>USPS</label>
                    </div>
                    <div className='px-5'>
                        <button className="SaveBtn" onClick={() => DefaultShipMethodCall(LogInSchoolID, defaultShipMethod, setLoading, setNewAlerts)}> Confirm   </button>
                    </div>
                </div>
            </SettingBoxWrapper>
        </>
    )
}
